import {
  FeatureContext,
  MTE_NOT_PAT_CONFIRMATION,
  MTE_PAT_CONFIRMATION,
  NEW_PRODUCTS_COMMUNICATION_VIEWED,
  PAT_TRANSFER_ENABLED,
  PLATFORM_NOT_PAT_CONFIRMATION,
  PLATFORM_PAT_CONFIRMATION,
  ToggleContext,
} from '@benefits/features';
import { useAccessControl } from '@ifb-b2b-iam/access-control';
import { useContext } from 'react';

export const useCommunicationNewProducts = () => {
  const { acl } = useAccessControl();

  const featureFlagContext = useContext(FeatureContext);
  const featureTogglesContent = useContext(ToggleContext);

  const isUserAdmin = !!acl?.has('access');

  const isCommunicationNewProductsEnabled = Boolean(
    featureTogglesContent?.isEnable('NEW_PRODUCTS_COMMUNICATION_ENABLED')
  );

  const commonValidation = isUserAdmin && isCommunicationNewProductsEnabled;

  const IS_MTE_PAT_CONFIRMATION = featureFlagContext?.isEnable(MTE_PAT_CONFIRMATION);
  const IS_NEW_PRODUCTS_COMMUNICATION_VIEWED = featureFlagContext?.isEnable(NEW_PRODUCTS_COMMUNICATION_VIEWED);
  const IS_MTE_NOT_PAT_CONFIRMATION = featureFlagContext?.isEnable(MTE_NOT_PAT_CONFIRMATION);
  const IS_PAT_TRANSFER_ENABLED = featureFlagContext?.isEnable(PAT_TRANSFER_ENABLED);
  const IS_PLATFORM_PAT_CONFIRMATION = featureFlagContext?.isEnable(PLATFORM_PAT_CONFIRMATION);
  const IS_PLATFORM_NOT_PAT_CONFIRMATION = featureFlagContext?.isEnable(PLATFORM_NOT_PAT_CONFIRMATION);

  const showPATCommunication = commonValidation && IS_MTE_PAT_CONFIRMATION && !IS_NEW_PRODUCTS_COMMUNICATION_VIEWED;

  const showNotPATCommunication =
    commonValidation &&
    IS_MTE_NOT_PAT_CONFIRMATION &&
    IS_PAT_TRANSFER_ENABLED &&
    !IS_PLATFORM_PAT_CONFIRMATION &&
    !IS_PLATFORM_NOT_PAT_CONFIRMATION;

  const showCommunication = showPATCommunication || showNotPATCommunication;

  return {
    showCommunication,
    showPATCommunication,
    showNotPATCommunication,
  };
};
